import React, { FunctionComponent, useState } from 'react';

import { AccordionType } from '../types';

const Accordion: FunctionComponent<AccordionType> = ({ id, defaultActive = 0, children }) => {
  const [active, setActive] = useState(defaultActive);

  return (
    <div className="accordion" id={id}>
      {children &&
        children.map((child: any, index: number) => {
          return React.cloneElement(child, {
            active: active === index,
            index: index,
            keyItem: child.key,
            setActive: setActive,
          });
        })}
    </div>
  );
};

export default Accordion;
